import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from "@mui/material";
import axiosInstance from "../../utils/axiosInstance";
import CustomButton from "../../components/CustomButton";

const NomineeDetails = () => {
  const navigate = useNavigate();
  const [hasNomineeData, setHasNomineeData] = useState(false);
  const [nomineeDetails, setNomineeDetails] = useState({
    dob: "",
    email: "",
    name: "",
    phone: "",
    relation: "",
  });

  const [errors, setErrors] = useState({
    dob: false,
    email: false,
    name: false,
    phone: false,
    relation: false,
  });

  useEffect(() => {
    const login = sessionStorage.getItem("token");
    if (!login) {
      navigate("/");
    } else {
      getNomineeDetails();
    }
  }, []);

  const getNomineeDetails = async () => {
    try {
      const res = await axiosInstance.get("/nominee/listNominee");
      if (res.data && res.data.data && res.data.data.length > 0) {
        const item = res.data.data[0];
        setNomineeDetails({
          dob: item.dob,
          email: item.email,
          name: item.name,
          phone: item.phone,
          relation: item.relation,
        });
        setHasNomineeData(true);
      } else {
        setHasNomineeData(false);
      }
    } catch (error) {
      console.log("ERROR IN CATCH=====>>", error);
      setHasNomineeData(false);
    }
  };
  // const getNomineeDetails = () => {
  //   axios
  //     // .get(`${import.meta.env.VITE_BASE_URL}/nominee/listNominee`, { headers })
  //     .get(`${process.env.REACT_APP_BASE_URL}/nominee/listNominee`, { headers })
  //     .then((response) => {
  //       if (
  //         response.data &&
  //         response.data.data &&
  //         response.data.data.length > 0
  //       ) {
  //         const item = response.data.data[0];
  //         setNomineeDetails({
  //           dob: item.dob,
  //           email: item.email,
  //           name: item.name,
  //           phone: item.phone,
  //           relation: item.relation,
  //         });
  //         setHasNomineeData(true);
  //       } else {
  //         setHasNomineeData(false);
  //       }
  //     })
  //     .catch((error) => {
  //       console.error("Error fetching nominee details:", error);
  //       setHasNomineeData(false);
  //     });
  // };

  const validateField = (name, value) => {
    let isValid = true;
    switch (name) {
      case "dob":
        isValid = value.trim() !== "";
        break;
      case "email":
        isValid = /\S+@\S+\.\S+/.test(value);
        break;
      case "name":
        isValid = value.trim() !== "";
        break;
      case "relation":
        isValid = value.trim() !== "";
        break;
      default:
        break;
    }
    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: !isValid,
    }));
    return isValid;
  };

  const inputHandler = (e) => {
    const { name, value } = e.target;
    setNomineeDetails({ ...nomineeDetails, [name]: value });
    validateField(name, value);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const isFormValid = Object.keys(nomineeDetails).every((key) => {
      if (key === "phone") return true; // Phone is optional
      return validateField(key, nomineeDetails[key]);
    });

    if (!isFormValid) return;

    try {
      const response = await axiosInstance.post("/nominee/add", nomineeDetails);

      if (!response.data.error) {
        Swal.fire({
          icon: "success",
          title: "Nominee details updated successfully",
        });
        await getNomineeDetails();
      } else {
        Swal.fire({
          title: "Failed to save nominee details!",
          text: response.data.data.message || "something went wrong!",
          icon: "error",
        });
      }
    } catch (error) {
      console.log("ERROR IN NOMNEE API=============>>>>", error);
    }
  };
  return (
    <div>
      <section id="NomineeDetails">
        <form onSubmit={handleSubmit}>
          <div className="row">
            <div className="col-sm-6">
              <div className="mb-3">
                <TextField
                  label="Name"
                  size="small"
                  type="text"
                  className={`form-control ${errors.name ? "is-invalid" : ""}`}
                  id="name"
                  name="name"
                  placeholder="Enter your name"
                  onChange={inputHandler}
                  value={nomineeDetails.name}
                  required
                />
                {errors.name && (
                  <div className="invalid-feedback">Name is required</div>
                )}
              </div>
            </div>
            <div className="col-sm-6">
              <div className="mb-3">
                <TextField
                  label="Date Of Birth"
                  size="small"
                  type="date"
                  className={`form-control ${errors.dob ? "is-invalid" : ""}`}
                  id="dob"
                  name="dob"
                  placeholder="Enter your date of birth"
                  onChange={inputHandler}
                  value={nomineeDetails.dob}
                  required
                  InputLabelProps={{ shrink: true }}
                />
                {errors.dob && (
                  <div className="invalid-feedback">
                    Date of Birth is required
                  </div>
                )}
              </div>
            </div>
            <div className="col-sm-6">
              <div className="mb-3">
                <FormControl fullWidth size="small" required>
                  <InputLabel id="relationship-select-label">
                    Relationship
                  </InputLabel>
                  <Select
                    labelId="relationship-select-label"
                    id="relationship-select"
                    name="relation"
                    value={nomineeDetails.relation || ""}
                    label="Relationship"
                    onChange={inputHandler}
                  >
                    <MenuItem value="" disabled>
                      Select Relationship
                    </MenuItem>
                    <MenuItem value="Brother">Brother</MenuItem>
                    <MenuItem value="Father">Father</MenuItem>
                    <MenuItem value="Mother">Mother</MenuItem>
                    <MenuItem value="Husband">Husband</MenuItem>
                    <MenuItem value="Wife">Wife</MenuItem>
                    <MenuItem value="Sister">Sister</MenuItem>
                    <MenuItem value="Son">Son</MenuItem>
                    <MenuItem value="Daughter">Daughter</MenuItem>
                    <MenuItem value="Other">Other</MenuItem>
                  </Select>
                </FormControl>
                {errors.relation && (
                  <div className="invalid-feedback">
                    Relationship is required
                  </div>
                )}
              </div>
            </div>
            <div className="col-sm-6">
              <div className="mb-3">
                <TextField
                  label="Email"
                  size="small"
                  type="email"
                  className={`form-control ${errors.email ? "is-invalid" : ""}`}
                  id="email"
                  name="email"
                  placeholder="Enter your email"
                  onChange={inputHandler}
                  value={nomineeDetails.email}
                  required
                />
                {errors.email && (
                  <div className="invalid-feedback">Invalid email address</div>
                )}
              </div>
            </div>
            <div className="col-sm-6">
              <div className="mb-3">
                <TextField
                  label="Mobile Number"
                  size="small"
                  type="text"
                  className={`form-control ${errors.phone ? "is-invalid" : ""}`}
                  id="mobileNumber"
                  name="phone"
                  placeholder="Enter mobile number"
                  onChange={inputHandler}
                  value={nomineeDetails.phone}
                  inputProps={{
                    maxLength: 10,
                    inputMode: "numeric", // shows numeric keypad on mobile
                    pattern: "[0-9]*",
                  }}
                  onInput={(e) => {
                    e.target.value = e.target.value.replace(/[^0-9]/g, ""); // removes non-numeric
                  }}
                  required
                />

                {errors.phone && (
                  <div className="invalid-feedback">
                    Please enter a valid 10-digit phone number
                  </div>
                )}
              </div>
            </div>
          </div>
          {!hasNomineeData && (
            <div style={{ display: "flex" }}>
              <CustomButton label="Submit" type="submit" />
            </div>
          )}
        </form>
      </section>
    </div>
  );
};

export default NomineeDetails;
